/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2024-07-21 17:04:05
 * @LastEditTime: 2024-07-21 19:57:31
 * @LastEditors: 赵大壮
 */
import config from '../nyConfig'
const ApiArticle = {
    "添加分类": new config({ url: '/article/addType', showSuccessMessage: true, useToken: true }),
    "修改分类": new config({ url: '/article/editType', showSuccessMessage: true, useToken: true }),
    "删除分类": new config({ url: '/article/delType', showSuccessMessage: true, useToken: true }),
    "分类列表": new config({ url: '/article/listType', showSuccessMessage: false, useToken: true }),
    "分类字典列表": new config({ url: '/article/listTypeDic', showSuccessMessage: false, useToken: true }),
    "添加文章": new config({ url: '/article/addInfo', showSuccessMessage: true, useToken: true }),
    "编辑文章": new config({ url: '/article/editInfo', showSuccessMessage: true, useToken: true }),
    "删除文章": new config({ url: '/article/delInfo', showSuccessMessage: true, useToken: true }),
    "添加视频号": new config({ url: '/article/addWorks', showSuccessMessage: true, useToken: true }),
    "删除视频号": new config({ url: '/article/delWorks', showSuccessMessage: true, useToken: true }),
    "文章列表": new config({ url: '/article/listInfo', showSuccessMessage: false, useToken: true }),
    "文章详情": new config({ url: '/article/getInfo', showSuccessMessage: false, useToken: true }),
    "所有文章": new config({ url: '/article/listArticleInfoAll', showSuccessMessage: false, useToken: true }),
    "修改文章排序": new config({ url: '/article/saveSort', showSuccessMessage: true, useToken: true }),
    "数据上移": new config({ url: '/article/moveUp', showSuccessMessage: true, useToken: true }),
    "数据下移": new config({ url: '/article/moveDown', showSuccessMessage: true, useToken: true }),
    "数据置顶": new config({ url: '/article/moveTop', showSuccessMessage: true, useToken: true }),
    "取消置顶": new config({ url: '/article/cancelTop', showSuccessMessage: true, useToken: true })
}

export default ApiArticle